import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import ResponsiveImage from './ResponsiveImage';
import { hunit } from '../lib/style-helpers';

const cardTopCSS = css`
  margin: 0 -${hunit(3)};
  position: relative;
`;

const CardTop = ({ icon, imageUrl, ...props }) => (
  <div css={cardTopCSS} {...props}>
    <ResponsiveImage src={imageUrl}>{ icon }</ResponsiveImage>
  </div>
);

CardTop.defaultProps = {
  icon: undefined,
};

CardTop.propTypes = {
  icon: PropTypes.node,
  imageUrl: PropTypes.string.isRequired,
};

export default CardTop;
